import { ContentHeader, IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { SummaryCardServiceProps } from '@common/review';
import { ConditionLink, UxReviewListOrderType } from '@domains/review-list-common';

import { Comment } from '../component/Comment';
import { ReviewRating } from '../component/ReviewRating';
import { SwiperSection } from '../component/Section';
import { SummaryCard } from '../component/SummaryCard';
import { ViewMore } from '../component/ViewMore';
import { useSummaryCardUBL } from '../log/useSummaryCardUBL';
import { useSummaryCardService } from '../service/useSummaryCardService';

export function SummaryCardContainer(props: SummaryCardServiceProps) {
  const service = useSummaryCardService(props);
  const log = useSummaryCardUBL();

  if (!service.show_summary_section) {
    return null;
  }

  return (
    <Container>
      <ContentHeader.Container>
        <ContentHeader.LeftSection>
          <ContentHeader.Label>리뷰</ContentHeader.Label>
          <ContentHeader.Number value={service.totalCount} />
        </ContentHeader.LeftSection>
        <ContentHeader.RightSection>
          <ContentHeader.TextButton
            icon={IconArrowRightBold}
            onClick={() => {
              log.clickAllButton();
              service.handleViewMoreFromTab?.();
            }}
          >
            전체보기
          </ContentHeader.TextButton>
        </ContentHeader.RightSection>
      </ContentHeader.Container>
      <ReviewRating average={service.ratings_average} />
      {service.show_summary_comment &&
        typeof service.summary.text === 'string' &&
        typeof service.summary.label === 'string' &&
        typeof service.summary.percent === 'number' && (
          <Comment
            isZigzagApp={service.isZigzagApp}
            label={service.summary.label}
            text={service.summary.text}
            percent={service.summary.percent}
          />
        )}
      <SwiperSection
        isApp={service.isZigzagApp}
        item_list={service.review_list}
        renderItem={(props, index) =>
          service.isZigzagApp ? (
            <div key={props.id}>
              <SummaryCard
                contents={props.contents}
                thumbnail={props.thumbnail}
                type={props.type}
                key={props.id}
                onClick={() => {
                  service.openPhotoReviewInApp(props.id);
                  log.clickPhotoThumbnail({ review_id: props.id, object_idex: index });
                }}
                onImpression={() => {
                  log.impressionReviewSummary({ review_id: props.id, object_idex: index });
                }}
                isReported={props.isReported}
              />
            </div>
          ) : (
            <ConditionLink
              key={props.id}
              href={
                props.isReported
                  ? ''
                  : service
                      .reveiwListUrl({
                        review_id: props.id,
                        feedType: 'summary',
                        order_type: UxReviewListOrderType.EXPERIENCE_GROUP_BEST_SCORE_DESC,
                      })
                      .toString()
              }
            >
              <SummaryCard
                contents={props.contents}
                thumbnail={props.thumbnail}
                key={props.id}
                type={props.type}
                onClick={() => {
                  log.clickPhotoThumbnail({ review_id: props.id, object_idex: index });
                }}
                onImpression={() => {
                  log.impressionReviewSummary({ review_id: props.id, object_idex: index });
                }}
                isReported={props.isReported}
              />
            </ConditionLink>
          )
        }
        lastChild={
          service.show_more_item && (
            <ViewMore
              onClick={() => {
                log.clickAllButton();
                service.handleViewMoreFromTab?.();
              }}
            />
          )
        }
      />
    </Container>
  );
}

const Container = styled.div`
  padding: 4px 0;
  border-top: 8px solid ${vars.v3Color.gray100};
`;
